import { createTheme } from "@mui/material/styles"
import { sharedTheme } from "ui"
import colors from "./colors"
const customTheme = createTheme({
  ...sharedTheme,
})

export const theme = {
  ...customTheme,
  colors,
}

export type Theme = typeof theme
